exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".card-salarie-header .text-default[data-v-0a16c83c]{color:#000;text-transform:none;font-size:.7em;display:inline-block;margin-top:10px}.noselect[data-v-0a16c83c]{-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-0a16c83c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./src/components/gestionDesAbsences/situationDesAbsences/situationDesAbsences.scss
// module id = UAwc
// module chunks = 2